
export class Infra {
    id_infra:number;
    libelle_infra:any;
    image_infra:any;
    etat_infra : any;
    etat_infra_2:any;
    date_infra:Date;
    etat_infra_3:any;
   
       
    constructor(id_infra:number){
           
    }
}
